import { Link } from "react-router-dom";

//#region src/components/button/shared.ts
const getButtonProps = (props) => {
	const { link, onClick, to, type, form, ...restProps } = props;
	if (link) return {
		component: Link,
		to,
		onClick,
		...restProps
	};
	return {
		onClick,
		type,
		form,
		...restProps
	};
};

//#endregion
export { getButtonProps };